import React from 'react';
import AlertBar from '../common/AlertBar';

const RegionSupportAlert = () => (
  <AlertBar className="region-support-alert" alertType="warning">
    <strong>Ad Studio is US-only</strong>. We&#39;re currently testing Ad Studio with US advertisers. We will be adding more countries soon!
  </AlertBar>
);

export default RegionSupportAlert;



// WEBPACK FOOTER //
// ./src/components/Alerts/RegionSupportAlert.js